import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import BenefitsGrid from "../BenefitsGrid";

import * as styles from "./customtabs.module.css";
import "react-accessible-accordion/dist/fancy-example.css";

import { useI18next } from "gatsby-plugin-react-i18next";

export default function CustomTabs({ tabs, onTabChange }) {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const [filteredTabs, setFilteredTabs] = React.useState(tabs);
  const { language } = useI18next();

  React.useEffect(() => {
    setFilteredTabs(
      tabs.filter((tab) => !tab.regions || tab.regions && tab.regions.includes(language))
    );
    setSelectedTab(0);
  }, [tabs, language]);
  
  return (
    <>
      <div className={styles.customTabs}>
        <div className={styles.tabs}>
          {filteredTabs.map((tab, index) => (
            <div
              key={index}
              className={`${styles.tab} ${
                selectedTab === index ? styles.selected : ""
              }`}
              onClick={() => {
                setSelectedTab(index);
                if (onTabChange) onTabChange(index);
              }}
            >
              {tab.title}
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          <div className={styles.productInfoParent}>
            <p className={styles.productDescription}>
              {filteredTabs[selectedTab].description}
            </p>

            {filteredTabs[selectedTab].specs && filteredTabs[selectedTab].specs.length ? (
              <Accordion
                className={styles.productSpecs}
                allowZeroExpanded={true}
              >
                <AccordionItem className={styles.specs}>
                  <AccordionItemHeading className={styles.specsTitle}>
                    <AccordionItemButton className={styles.specsTitleText}>
                      Detailed Specifications
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel className={styles.specsContent}>
                    <table className={styles.specsTable}>
                      <tbody>
                        {filteredTabs[selectedTab].specs.map((spec, index) => (
                          <tr key={index}>
                            <td className={styles.specsTableKey}>{spec[0]}</td>
                            <td className={styles.specsTableValue}>
                              {spec[1]}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </AccordionItemPanel>
                </AccordionItem>
              </Accordion>
            ) : null}
          </div>
          {filteredTabs[selectedTab].img && (
            <div className={styles.productImageParent}>
              <img
                className={styles.productImage}
                src={filteredTabs[selectedTab].img}
                alt={filteredTabs[selectedTab].title}
              />
            </div>
          )}
        </div>
      </div>
      {tabs[selectedTab].features && tabs[selectedTab].features.length ? (
        <BenefitsGrid
          title={"Key features"}
          items={tabs[selectedTab].features}
        />
      ) : null}
    </>
  );
}
